import React  from 'react';
import PropTypes from 'prop-types';
import Footer from './components/Footer';
import '../../../assets/stylesheets/Layouts/Main.scss'
import {useSelector} from "react-redux";
import {getRoleInCurrentClub} from "../../../store/selectors";
import parameters from "../../../config/parameters";

const Main = props => {
  const { children } = props;
  const roleInClub = useSelector(getRoleInCurrentClub);

  return (
      <div className={`mainLayout`}>
        <main className={`pageContent`} >
          {children}
        </main>
          { roleInClub !== parameters.clubRoles.PLAYER && <Footer /> }
      </div>
  );
};

Main.propTypes = {
  children: PropTypes.node
};

export default Main;
